import { ControlledDocumentPickerModalController } from './controlled-document-picker-modal.controller';
import { ControlledDocumentPickerModalProps } from './controlled-document-picker-modal.model';

export const ControlledDocumentPickerModal = (
  props: ControlledDocumentPickerModalProps
) => {
  return <ControlledDocumentPickerModalController {...props} />;
};
